const React = require('react');

const UserTaskStore = require('stores/UserTaskStore'),
  SessionStore = require('stores/SessionStore'),
  DashboardStore = require('stores/DashboardStore'),
  {Tasks, TaskList, TaskItem} = require('components/Tasks/Tasks'),
  CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
  {Tabs, Tab} = require('components/Tabs/Tabs'),
  {t} = require('services/i18nextWrapper'),
  DashboardActionCreators = require('actions/DashboardActionCreators'),
  sortBy = require('lodash/collection').sortBy,
  DateUtils = require('utils/DateUtils');

const MAX_CHARACTER_ALLOWED_LIST_NAME = 50;

const UserTasks = React.createClass({displayName: "UserTasks",
  
  _timeouts: [],
  
  propTypes: {
    isUserTaskVisible: React.PropTypes.bool,
    onClickClose: React.PropTypes.func,
    onChangeDate: React.PropTypes.func,
    date: React.PropTypes.string
  },
  
  getInitialState() {
    return {
      date: this.props.date,
      isUserTaskFetching: true,
      scheduleBoardList: UserTaskStore.getScheduleBoardList(),
      notesHasSameStateMapping: this.initializeNotesStateMapping()
    };
  },
  
  initializeNotesStateMapping: function () {
    return UserTaskStore.getScheduleBoardList().reduce((mapping, item) => {
      return Object.assign(mapping, {[item.id]: true});
    }, {});
  },
  
  focusNewTask() {
    this._timeouts.push(setTimeout(() => {
      try {
        const newInput = Array.from(document.querySelectorAll('.bp-tab.is-active .task-item .task-item__message-input input')).pop();
        const textArea = Array.from(document.querySelectorAll('.bp-tab.is-active .task-item .task-item__message-input textarea')).pop();
        if (textArea) {
          textArea.focus();
        } else if (newInput) {
          newInput.focus();
        }
      } catch (error) {
        // do-nothing
      }
    }, 500)); // until end ant
  },
  
  componentWillMount() {
    UserTaskStore.addChangeListener(this.onChange);
  },
  
  componentWillUnmount() {
    UserTaskStore.removeChangeListener(this.onChange);
    this.cleanTimeouts();
  },
  
  cleanTimeouts() {
    if (this._timeouts && this._timeouts.length) {
      this._timeouts.forEach(timeout => clearTimeout(timeout));
    }
  },
  
  onChange() {
    this.setState({
      date: SessionStore.getUserTaskDate(),
      isUserTaskFetching: UserTaskStore.isUserTaskFetching(),
      scheduleBoardList: UserTaskStore.getScheduleBoardList()
    }, () => {
      this.focusNewTask();
    });
  },
  
  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeIndexTab !== this.state.activeIndexTab) {
      document.querySelector('.bp-tab-header.is-active').scrollIntoView();
    }
  },
  
  getDate() {
    const {
      scheduleBoardList,
      date
    } = this.state;
    
    let currentDate = date || scheduleBoardList[0].date;
    
    if (!currentDate) {
      currentDate = DateUtils.getCurrentDate();
    }
    return currentDate;
  },
  
  getScheduleFilter(currentDate) {
    let scheduleBoardFilter = (this.state.scheduleBoardList || []).filter(board => board.date === currentDate);
    
    if (!scheduleBoardFilter || scheduleBoardFilter.length === 0) {
      scheduleBoardFilter = [];
    }
    
    return sortBy(scheduleBoardFilter, 'name');
  },
  
  render() {
    const {isUserTaskFetching, activeIndexTab} = this.state;
    const {isUserTaskVisible, onClickClose, onChangeDate} = this.props;
    
    const currentDate = this.getDate();
    const scheduleBoardFilter = this.getScheduleFilter(currentDate);
    
    function showPleaseCreateTaskFirstMessage(scheduleBoardFilter) {
      return scheduleBoardFilter && scheduleBoardFilter.length === 0 &&
        React.createElement("label", {style: {paddingTop: '10px'}}, t('dashboard_user_task_label_please_create_list_first'));
    }
    
    return (
      React.createElement(Tasks, {
        date: currentDate, 
        isHidden: !isUserTaskVisible, 
        onOpen: () => this.focusNewTask(), 
        onChangeDate: (date) => onChangeDate(date), 
        onClickClose: () => {
          if (UserTaskStore.isAllChangesSaved()) {
            this.setState({scheduleDate: null});
            onClickClose();
          } else {
            CustomDialog.showWarningConfirmation(t('warning'), t('dashboard_user_task_notification_please_save_changes'), () => {
              UserTaskStore.resetAllChangesNote();
              this.setState({scheduleDate: null});
              onClickClose();
            });
          }
        }
      }, 
        React.createElement(Tabs, {
          activeIndexTab: activeIndexTab, 
          isLoading: isUserTaskFetching, 
          fetchList: () => DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(currentDate || DateUtils.getCurrentDate())), 
          onSaveNewTab: (name) => {
            DashboardActionCreators.saveChangedUserTaskName({
              date: DateUtils.toDateText(currentDate),
              name
            });
            selectedTab(this, null, scheduleBoardFilter, name);
          }, 
          onChangeTab: () => {
            this.focusNewTask();
          }, 
          onSaveChangedTab: (taskId, changedName, originalName, tabIndex) => {
            if (!changedName) {
              CustomDialog.showInfo('warning', t('dashboard_user_task_notification_not_allow_empty_list_name'));
              return;
            }
            if (changedName.length > MAX_CHARACTER_ALLOWED_LIST_NAME) {
              DashboardStore.unsetIsSavedDraft();
              CustomDialog.showInfo('warning', t('dashboard_user_task_list_inline_error_name_max_amount'));
              return;
            }
            DashboardActionCreators.saveChangedUserTaskName({
              date: DateUtils.toDateText(currentDate),
              name: changedName,
              originalName,
              id: taskId
            });
            selectedTab(this, tabIndex, scheduleBoardFilter, name);
          }, 
          onDeleteExistingTab: (taskId, taskName) => {
            DashboardActionCreators.deleteUserTaskName(taskId, taskName);
            selectedTab(this, 0, scheduleBoardFilter, name);
          }
        }, 
          scheduleBoardFilter.length > 0 && scheduleBoardFilter.map(taskList => {
            return React.createElement(Tab, {
              key: `tab-key-id-${taskList.id}-${taskList.name}`, 
              id: taskList.id, 
              label: taskList.name
            }, 
              React.createElement(TaskList, null, 
                showExistingTasks(taskList, currentDate, this), 
                showNewEmptyTask(taskList, currentDate, this)
              )
            );
          })
        ), 
        showPleaseCreateTaskFirstMessage(scheduleBoardFilter)
      )
    );
  }
  
});

function showNewEmptyTask(taskList, currentDate, self) {
  return taskList.id && React.createElement(TaskItem, {
    key: `task-new-${String(Math.random()).slice(2, 20)}`, 
    ref: ref => {
      if (ref) {
        self._el = ref;
      }
    }, 
    "data-task-new-id": "task-item-id", 
    deleteDisabled: true, 
    isEditMode: true, 
    message: "", 
    name: "", 
    onChange: () => {
    }, 
    checked: false, 
    onSave: ({note, name, checked}) => {
      DashboardActionCreators.addUserTaskName({
        note,
        name,
        checked,
        id: null, // because it's new task
        date: DateUtils.toDateText(currentDate),
        listId: taskList.id,
        listName: taskList.name
      });
      
    }, 
    onDelete: () => {/* do nothing because is new */
    }}
  );
}

function showExistingTasks(taskList, currentDate) {
  return taskList.tasks.length
    ? sortBy(taskList.tasks, 'id')
    .map(task => (
      React.createElement(TaskItem, {
        key: `task-item-filled-${task.id || task.name}`, 
        "data-task-new-id": "task-item-id", 
        message: task.message, 
        name: task.name, 
        checked: task.checked, 
        onSave: ({note, name, checked}) => {
          DashboardActionCreators.addUserTaskName({
            note,
            name,
            checked,
            id: task.id,
            date: DateUtils.toDateText(currentDate),
            listId: taskList.id,
            listName: taskList.name
          });
          UserTaskStore.markAsSavedNote(task);
        }, 
        onChange: (changedNote) => UserTaskStore.onChangeNote(task, changedNote), 
        onDelete: () => {
          CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_user_task'), () => {
            DashboardActionCreators.removeUserTask({
              id: task.id,
              listId: taskList.id
            });
          });
        }}
      )
    ))
    : null;
}

function selectedTab(self, currentIndex, scheduleBoardFilter, name) {
  self._timeouts.push(setTimeout(() => {
    self.cleanTimeouts();
    const activeIndexTab = currentIndex !== null
      ? currentIndex :
      sortBy(scheduleBoardFilter.concat([{name}]), 'name').findIndex(item => item.name === name);
    // simulate as the tab already was there, so I simulate to add it, and sort it to
    // be sure that the index will be the right once when the real item arrives from the API response.
    self.setState({activeIndexTab}, () => self.focusNewTask());
  }, 1000));
}

module.exports = UserTasks;


/** WEBPACK FOOTER **
 ** ./src/components/UserTask/UserTask.jsx
 **/